import { Image } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAgent } from "../../../context/AgentContext";
import { useLogin } from "../../../context/LoginContext";
import { envChangeType, envType } from "../../../plugins/utils";
import { useDefaultLayout } from "../../defaultLayout";
import {
  AgentIcon,
  DepositIcon,
  HomeIcon,
  ProfileIcon,
  PromoIcon,
  TheaterIcon,
} from "./images/1bbetv3";
import styles from "./styleModule";
const Footer = () => {
  const [currentMod, setCurrentMod] = useState("home");
  const { checkLoginProcess } = useDefaultLayout();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { checkIfLogin } = useLogin();
  const { openDrawerAgent } = useAgent();
  const showTheater = envChangeType("REACT_APP_SHOW_THEATER", envType.BOOLEAN) === true;

  const items = [
    {
      id: "lobby",
      name: t("1bbet.footer.lobby"),
      icon: (
        <HomeIcon color1={"var(--footer-icon-inactive1)"} color2={"var(--footer-icon-inactive2)"} />
      ),
      icon_active: (
        <HomeIcon color1={"var(--footer-icon-active1)"} color2={"var(--footer-icon-active2)"} />
      ),
      path: "/",
      clickAction: () => navigate("/"),
      style: "",
      textStyle: "",
      showBadge: false,
    },
    {
      id: "promo",
      name: t("1bbet.footer.promo"),
      icon: (
        <PromoIcon
          color1={"var(--footer-icon-inactive1)"}
          color2={"var(--footer-icon-inactive2)"}
        />
      ),
      icon_active: (
        <PromoIcon color1={"var(--footer-icon-active1)"} color2={"var(--footer-icon-active2)"} />
      ),
      path: "/bonus",
      clickAction: () => navigate("/bonus"),
      style: "",
      textStyle: "",
      showBadge: false,
    },
    {
      id: "agent",
      name: envChangeType("REACT_APP_HIDE_AGENT", envType.BOOLEAN)
        ? t("normal.vip")
        : t("home.agent"),
      icon: (
        <AgentIcon
          color1={"var(--footer-agent-background-color1)"}
          color2={"var(--footer-agent-background-color2)"}
          strokeColor={"var(--footer-agent-stroke-color"}
        />
      ),
      icon_active: (
        <AgentIcon
          color1={"var(--footer-agent-background-color1)"}
          color2={"var(--footer-agent-background-color2)"}
          strokeColor={"var(--footer-agent-stroke-color"}
        />
      ),
      path: "/agent",
      clickAction: () => {
        if (envChangeType("REACT_APP_HIDE_AGENT", envType.BOOLEAN)) {
          navigate("/vip");
        } else {
          openDrawerAgent();
        }
      },
      style: styles.agentIconContainer,
      textStyle: styles.agentIconText,
      showBadge: false,
    },
    {
      id: "deposit",
      name: t("1bbet.footer.deposit"),
      icon: (
        <DepositIcon
          color1={"var(--footer-icon-inactive1)"}
          color2={"var(--footer-icon-inactive2)"}
        />
      ),
      icon_active: (
        <DepositIcon color1={"var(--footer-icon-active1)"} color2={"var(--footer-icon-active2)"} />
      ),
      path: "/exchange",
      clickAction: () => navigate("/exchange"),
      style: "",
      textStyle: "",
      showBadge: false,
    },
    {
      id: "profile",
      name: t("1bbet.footer.profile"),
      icon: (
        <ProfileIcon
          color1={"var(--footer-icon-inactive1)"}
          color2={"var(--footer-icon-inactive2)"}
        />
      ),
      icon_active: (
        <ProfileIcon color1={"var(--footer-icon-active1)"} color2={"var(--footer-icon-active2)"} />
      ),
      path: "/personal",
      clickAction: () => navigate("/personal"),
      style: "",
      textStyle: "",
      showBadge: false,
    },
  ];

  const theaterItems = [
    {
      id: "lobby",
      name: t("1bbet.footer.lobby"),
      icon: (
        <HomeIcon color1={"var(--footer-icon-inactive1)"} color2={"var(--footer-icon-inactive2)"} />
      ),
      icon_active: (
        <HomeIcon color1={"var(--footer-icon-active1)"} color2={"var(--footer-icon-active2)"} />
      ),
      path: "/",
      clickAction: () => navigate("/"),
      style: "",
      textStyle: "",
      showBadge: false,
    },
    {
      id: "promo",
      name: t("1bbet.footer.promo"),
      icon: (
        <PromoIcon
          color1={"var(--footer-icon-inactive1)"}
          color2={"var(--footer-icon-inactive2)"}
        />
      ),
      icon_active: (
        <PromoIcon color1={"var(--footer-icon-active1)"} color2={"var(--footer-icon-active2)"} />
      ),
      path: "/bonus",
      clickAction: () => navigate("/bonus"),
      style: "",
      textStyle: "",
      showBadge: false,
    },
    {
      id: "shorts",
      name: t("1bbet.footer.shorts"),
      icon: (
        <AgentIcon
          color1={"var(--footer-agent-background-color1)"}
          color2={"var(--footer-agent-background-color2)"}
          strokeColor={"var(--footer-agent-stroke-color"}
        />
      ),
      icon_active: (
        <AgentIcon
          color1={"var(--footer-agent-background-color1)"}
          color2={"var(--footer-agent-background-color2)"}
          strokeColor={"var(--footer-agent-stroke-color"}
        />
      ),
      path: "/shorts",
      clickAction: () => navigate("/shorts"),
      style: styles.agentIconContainer,
      textStyle: styles.agentIconText,
      showBadge: false,
    },
    {
      id: "theater",
      name: t("1bbet.footer.theater"),
      icon: (
        <TheaterIcon
          color1={"var(--footer-icon-inactive1)"}
          color2={"var(--footer-icon-inactive2)"}
        />
      ),
      icon_active: (
        <TheaterIcon color1={"var(--footer-icon-active1)"} color2={"var(--footer-icon-active2)"} />
      ),
      path: "/theater",
      clickAction: () => navigate("/theater"),
      style: "",
      textStyle: "",
      showBadge: false,
    },
    {
      id: "profile",
      name: t("1bbet.footer.profile"),
      icon: (
        <ProfileIcon
          color1={"var(--footer-icon-inactive1)"}
          color2={"var(--footer-icon-inactive2)"}
        />
      ),
      icon_active: (
        <ProfileIcon color1={"var(--footer-icon-active1)"} color2={"var(--footer-icon-active2)"} />
      ),
      path: "/personal",
      clickAction: () => navigate("/personal"),
      style: "",
      textStyle: "",
      showBadge: false,
    },
  ];

  const footerItems = showTheater ? theaterItems : items;

  const updateCurrentMod = () => {
    const target = footerItems.find((m) => m.path === window.location.pathname);
    setCurrentMod(target?.id);
  };

  useEffect(() => {
    updateCurrentMod();
  }, [window.location.pathname, showTheater]);

  const onHandleFooterClick = (item) => {
    if (!checkIfLogin()) return;

    if (!checkLoginProcess?.process()) {
      return;
    }

    item.clickAction();
  };

  return (
    <div className={styles.footerContainer}>
      <div className={styles.footer}>
        {footerItems.map((item) => {
          return (
            <div
              className={styles.footerItem}
              onClick={() => onHandleFooterClick(item)}
              key={item.id}
            >
              <div className={`${styles.iconContainer} ${item.style}`}>
                {item.id === currentMod ? item.icon_active : item.icon}
              </div>
              <div
                className={`${styles.text} ${item.id === currentMod ? styles.textActive : ""} ${
                  item.textStyle
                }`}
              >
                {item.name}
              </div>
              {item.showBadge && (
                <div className={styles.badgeContainer}>
                  <Image
                    src={`/images/logo/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/badge.png`}
                    alt="badge"
                    width={26}
                    height={26}
                    preview={false}
                  />
                  <span className={styles.text}>
                    {envChangeType("REACT_APP_FOOTER_BADGE_TEXT")}
                  </span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Footer;
